/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

import { ApplicationActions } from '../../../actions/application.actions';
import * as _ from 'lodash';

@Component({
  selector: 'account-type',
  template: require('./account-type.component.html'),
})
export class AccountTypeComponent extends BaseRoute {
  constructor(injector: Injector, appActions: ApplicationActions) {
    super(injector);
    this.appActions = appActions;

    if (
      this.flowManager.isAuthed &&
      !this.appActions.getData('PersonalInformation')
    ) {
      this.flowManager.updatePersonalInfoACMRedux((acmComplete) => {
        this.setPrePropSteps();
      });
    }
    this.nonPaperAccounts = [
      'select-individual',
      'select-joint',
      'select-custodial',
      'select-roth',
      'select-traditional',
      'select-rollover',
    ];

    this.prepopAccountRoutes = {
      'select-roth': '/primary-beneficiary-info',
      'select-traditional': '/primary-beneficiary-info',
      'select-rollover': '/primary-beneficiary-info',
      'select-joint': '/joint-info',
      'select-custodial': '/custodial-minor-info',
      'select-individual': '/submit-application',
    };

    // Make sure these match ira type order at least for the first
    this.iraRadios = ['roth', 'traditional', 'rollover'];
    this._iraToggle(this.iraState);

    // State toggles
    if (this.showAll === true) this._showAllAccounts();
  }

  ngOnInit() {
    const account = this.flowManager.getAccountType();
    if (account !== '') {
      this.decisionOnPath(account);
    }

    if (this.flowManager.getAppType() === 'tka') {
      const accountTaxType = this.flowManager.accountTaxType; // MP accountTaxType from questionnaire
      let hideAccounts = [];

      if (accountTaxType === 'taxAdvantaged') {
        // Non-taxable (show IRAs)
        hideAccounts = ['individual', 'joint', 'custodial'];
        this.form.inputs.selectParagraph.showUp = false;
      } else if (accountTaxType === 'taxable') {
        // Taxable (hide IRAs)
        hideAccounts = ['traditional', 'roth', 'rollover'];
      }

      if (hideAccounts.length > 0) {
        for (let i of hideAccounts) {
          this.form.inputs.allAccounts.radios[i].showUp = false;
        }
      }
    }
  }

  get iraState() {
    return this.flowManager.getAppType() === 'tka'
      ? [true, false]
      : this.appActions.getData('appState.iraType', [false, false]);
  }

  set iraState(value) {
    this.appActions.setData('appState.iraType', value);
  }

  get showAll() {
    return this.appActions.getData('appState.showAllAccounts', false);
  }

  set showAll(value) {
    this.appActions.setData('appState.showAllAccounts', value);
  }

  isValidOccupation() {
    return (
      this.route.data.value.occupationList.filter(
        (item) =>
          item.value.toLowerCase() ===
          this.appActions
            .getData('EmploymentInformation.employed.occupation', '')
            .toLowerCase()
      ).length > 0
    );
  }

  decisionOnPath(account) {
    if (account === 'ira') return;
    if (!this.nonPaperAccounts.includes(account)) {
      this.nextRoute = '/paper-account';
    } else if (this.flowManager.isAuthed === true) {
      if (this.flowManager.prepoppedValid === true) {
        const { annualIncome, netWorth, liquidNetWorth } =
          this.route.data.value.incomeList.incomeValues;
        if (!this.isValidOccupation()) {
          this.nextRoute = '/employment-info';
        } else if (
          annualIncome.filter(
            (id) =>
              id.name ===
              this.appActions.getData('FinancialInformation.annualIncome')
          ).length < 1 ||
          netWorth.filter(
            (id) =>
              id.name ===
              this.appActions.getData('FinancialInformation.netWorth')
          ).length < 1 ||
          liquidNetWorth.filter(
            (id) =>
              id.name ===
              this.appActions.getData('FinancialInformation.liquidNetWorth')
          ).length < 1
        ) {
          // Check if the user's annual, networth and liquid networth is valid and matching the new amount range/pattern.
          // If not route the user to fianacial-info page
          this.nextRoute = '/financial-info';
        } else if (this.flowManager.getAppType() === 'tks') {
          this.nextRoute = '/investment-objective';
        } else {
          // navigate to appropriate account type route if tka and prepopped.
          // otherwise if not in defined object, send to default authed route
          this.nextRoute = this.prepopAccountRoutes[account]
            ? this.prepopAccountRoutes[account]
            : '/personal-info-auth';
        }
      } else {
        this.nextRoute = '/personal-info-auth';
      }
    } else {
      this.nextRoute = '/personal-info';
    }
  }

  _iraToggle(args) {
    this.iraState = args;
    const showUp = args[0] || false;
    const indent = args[1] || false;
    const iraRadios = this.iraRadios;
    const iraTitle =
      '<div class="col s12 margin-bottom-10 select-account-title">IRA Accounts</div>';
    this.form.inputs.allAccounts.radios[iraRadios[0]].title = indent
      ? ''
      : iraTitle;

    _.each(iraRadios, (type) => {
      this.form.inputs.allAccounts.radios[type].showUp = showUp;
      this.form.inputs.allAccounts.radios[
        type
      ].radioClass = `input-field-radio${indent ? ' padding-left-30' : ''}`;
    });
  }

  _showAllAccounts() {
    this.showAll = true;
    const accounts = this.form.inputs.allAccounts.radios;
    _.each(accounts, (account) => {
      /* eslint-disable */
      account.showUp = true;
      /* eslint-enable */
    });
    this.form.inputs.selectParagraph.showUp = true;
    this.form.inputs.allAccounts.radios.ira.showUp = false;
    this.form.inputs.viewAllAccounts.showUp = false;
    this._iraToggle([true, false]);
  }

  updateOptionValue(event) {
    const iraRadios = this.iraRadios;
    const appType = this.flowManager.getAppType();
    try {
      const eventTarget = event.srcElement || event.target;
      if (eventTarget !== undefined) {
        if (
          eventTarget.name === 'account_type' ||
          eventTarget.name === 'account_type'
        ) {
          this.flowManager.setAccountType(eventTarget.id);
          this.decisionOnPath(eventTarget.id);

          if (eventTarget.id === 'select-custodial') {
            this.appActions.deleteData('OptInInformation');
            this.appActions.deleteData('review./investment-preferences');
          }
        }
        if (eventTarget.id === 'viewAllAccounts') {
          this._showAllAccounts();
        }
      }

      if (
        event.id &&
        event.id === 'accountType' &&
        event.value != null &&
        appType !== 'tka'
      ) {
        const iraValue = event.value;
        if (iraValue === 'ira') {
          this._iraToggle([true, true]);
        } else if (
          this.showAll === false &&
          iraRadios.indexOf(iraValue.replace('select-', '')) === -1
        ) {
          this._iraToggle([false, true]);
        }
      }
    } catch (e) {
      console.log('event from other components', e);
    }
  }

  prepopStepsInputs(steps) {
    this.flowManager.prepoppedValid = true;

    Object.keys(steps).forEach((step) => {
      // Covered separately in the other calls
      if (step === 'personal-info-auth') {
        return;
      }

      _.forEach(steps[step].inputs, (input) => {
        if (input.showUp === true) {
          const inputValue = this.appActions.getData(input.inputPath);

          if (
            input.inputType === 'checkbox' &&
            input.inputs &&
            input.inputs.length > 0 &&
            inputValue === true
          ) {
            // Loop through all of the checkbox inputs
            _.forEach(input.inputs, (checkboxInput) => {
              const validateInput = this.validation.validate(
                checkboxInput.validationType,
                this.appActions.getData(checkboxInput.inputPath)
              );
              if (validateInput && validateInput.state === false) {
                this.flowManager.prepoppedValid = false;
                return false; // only way to break out of _.forEach
              }
            });
          } else if (
            input.inputType === 'employmentShow' &&
            this.appActions.getData(
              'appState.showVal.employmentStatus_Show',
              false
            ) === true
          ) {
            // Loop through all of the employmentShow inputs
            _.forEach(input.inputs, (employmentInput) => {
              const validateInput = this.validation.validate(
                employmentInput.validationType,
                this.appActions.getData(employmentInput.inputPath)
              );
              if (validateInput && validateInput.state === false) {
                this.flowManager.prepoppedValid = false;
                return false; // only way to break out of _.forEach
              }
            });
          } else if (input.validationType) {
            const validateInput = this.validation.validate(
              input.validationType,
              inputValue
            );
            if (validateInput && validateInput.state === false) {
              this.flowManager.prepoppedValid = false;
              return false; // only way to break out of _.forEach
            }
          }
        }
      });
    });

    // All good then populate the review steps
    if (this.flowManager.prepoppedValid === true) {
      // Only review personal info auth
      Object.keys(steps).forEach((step) => {
        if (
          ['personal-info-auth', 'employment-info', 'financial-info'].indexOf(
            step
          ) === -1
        ) {
          return;
        }

        _.forEach(steps[step].inputs, (input) => {
          if (
            input.inputType === 'checkbox' &&
            input.inputs &&
            input.inputs.length > 0
          ) {
            this.addReviewToRedux(step, input);

            // Loop through all of the checkbox inputs
            _.forEach(input.inputs, (checkboxInput) => {
              this.addReviewToRedux(step, checkboxInput);
            });
          } else if (
            input.inputType === 'employmentShow' &&
            this.appActions.getData(
              'appState.showVal.employmentStatus_Show',
              false
            ) === true
          ) {
            // Loop through all of the employmentShow inputs
            _.forEach(input.inputs, (employmentInput) => {
              this.addReviewToRedux(step, employmentInput);
            });
          } else if (
            input.showUp === true &&
            input.attr &&
            input.attr.id &&
            input.inputPath
          ) {
            this.addReviewToRedux(step, input);
          }
        });

        if (steps[step].reviewTitle != null) {
          this.appActions.setData(`review./${step}.options`, {
            label: steps[step].reviewTitle,
            route: `/${step}`,
            id: steps[step].reviewTitle.replace(/\s/g, '_'),
          });
        }
      });
    }
  }

  addReviewToRedux(step, input) {
    const fieldId = input.attr.id.replace(/\./, '_');
    const reviewPath = `review./${step}.${fieldId}`;
    const payload = {
      label: input.reviewLabel || input.label || fieldId,
      inputPath: input.inputPath,
    };

    if (input.optionsType != null) {
      payload.optionsType = input.optionsType;
    }

    if (input.maskingType != null) {
      payload.maskingType = input.maskingType;
    }

    this.appActions.setData(reviewPath, payload);
  }

  btnClick(e) {
    if (e.action === 'next') {
      if (this.isAuthed) {
        this.flowManager.logContactInfo();
      }
      this.router.navigate([this.nextRoute], {
        queryParamsHandling: 'preserve',
      });
    }
  }

  setPrePropSteps() {
    const prepopStepNames = [
      'personal-info-auth',
      'personal-address',
      'ssn',
      'personal-contact',
      'employment-info',
      'financial-info',
    ];
    const prepopSteps = {};
    prepopStepNames.forEach((step) => {
      this.appProxy.getFormJSON(
        this.flowManager.getAppType(),
        step,
        { isAuth: true },
        (res) => {
          if (res.form && res.form.inputs) {
            prepopSteps[step] = res.form;

            // Have we finished them all?
            if (Object.keys(prepopSteps).length === prepopStepNames.length) {
              prepopSteps[
                'personal-info-auth'
              ].inputs.securityAnswer.showUp = false;
              prepopSteps[
                'personal-info-auth'
              ].inputs.securityQuestion.showUp = false;
              prepopSteps[
                'personal-contact'
              ].inputs.securityAnswer.showUp = false;
              prepopSteps[
                'personal-contact'
              ].inputs.securityQuestion.showUp = false;
              this.prepopStepsInputs(prepopSteps);
            }
          }
        }
      );
    });
  }
}
